/**
 * Helper function to check if a product description should be displayed
 * @param {string|object|array} description - The product description
 * @returns {boolean} - True if description should be shown, false otherwise
 */
export function shouldShowProductDescription(description) {
  // If no description, don't show
  if (!description) return false;
  
  // If it's not a string, don't show (it's an object/array)
  if (typeof description !== 'string') return false;
  
  // If it contains "type": "alert", don't show
  if (description.includes('"type": "alert"') || description.includes("'type': 'alert'")) {
    return false;
  }
  
  // Otherwise, show it
  return true;
}

export default shouldShowProductDescription;
